import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { siteQueryOptions } from '@/features/auth/api';
import { LoginPage } from '@/features/auth/login-page';

export const Route = createFileRoute('/login')({
  validateSearch: z.object({ redirect: z.string().optional() }),
  // D49: the public demo shows no form, so the page waits to know which site this is.
  loader: ({ context }) => context.queryClient.query(siteQueryOptions),
  component: LoginPage,
});
